// SPDX-License-Identifier: LicenseRef-MMS-WIRE
// Copyright (c) 2016-2026 Metal Management Solutions (Pty) Ltd

import {CanActivateFn, Router} from '@angular/router';
import {firstValueFrom} from "rxjs";
import {inject} from "@angular/core";
import {AppScope} from "../app_scope.service";

export const onboardingUserGuard: CanActivateFn = async (route, state) => {
    const appScope = inject(AppScope);
    const router: Router = inject(Router);

    const isOnboarded = await firstValueFrom(appScope.userOnboarded);
    if (isOnboarded) {
        router.navigate(['']);
        return false;
    } else {
        return true;
    }
};
